import { render, staticRenderFns } from "./FindADoctor.vue?vue&type=template&id=83e1f3ca"
import script from "./FindADoctor.vue?vue&type=script&lang=js"
export * from "./FindADoctor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports